import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY = '/reports/campaign/<id>/stats';

export function useCampaignReportStatsQuery({
	campaignId,
	tags,
	impersonationContext,
	enabled = true,
}: {
	campaignId: string;
	tags: string[];
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.ICampaign>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `reports/campaign/${encodeURIComponent(campaignId)}/stats`,
					impersonationContext,
				}),
				'POST',
				{
					filter: {
						criteria: tags.map(value => ({
							property: Api.ContactFilterCriteriaProperty.Tag,
							value,
						})),
					},
				}
			),
		queryKey: [BASE_QUERY, campaignId, [...tags].sort(), impersonationContext?.account?.id],
		enabled: enabled && tags.length > 0,
	});
}
